import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Girls night and writing",
  "description": "",
  "published": "2009-01-25T00:00:00.000Z",
  "redirect_from": ["/blog/girls-night-and-writing/swizec/13"],
  "categories": "art, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On Friday my lovely lass had a girls night and left me stranded without anything much to do ... so I didn't.`}</p>
    <p>{`BUT! After a while I decided to do some writing since this big rush of ideas bubbled into my head, maybe I got smart 'cause I'm about to have a tumor eat my brain away, and I surprisingly managed to come up with five written pages of stuff, almost without crossing anything out, at Zeleni zajec over a cocktail. It was fun writing that much in one go after an extremely long time of not having been able to write anything of use. So over the last two days I managed to somewhat complete the tale, but put in a little cliffhanger at the end so I can continue this promising story about a dwarf and his wife at some other time.`}</p>
    <p>{`I also went to a striptease club where many interesting things happened, but I probably shouldn't write much about those experiences in such a public place. The fact that I've gone and that those things are a money pit should suffice. So without further ado, here's the first paragraph and the link to `}<a parentName="p" {...{
        "href": "http://3pike.org/tales/The_lonely_dwarf.rtf"
      }}>{`The Lonely Dwarf`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`There was once a dwarf called John who lived in a cottage deep inside the woods with his
wife Melinda. They led a happy existence full of daily little hurdles and exciting moments to
keep them going.

Their cottage wasn’t large, in fact you could say it was rather small, and it had
everything they needed. There was a large kitchen, so the dwarf could make his creations in,
 a small study for the dwarf and an adjacent library for them both. There was also a large
studio for Melinda to do her artistical musings in. She never really made anything of use /../
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      